import React from 'react'
import {Modal} from 'react-bootstrap'

type Props = {
  show: boolean
  onCancel: () => void
  onConfirm: () => void
}

const ConnectionTestRequiredModal: React.FC<Props> = ({show, onCancel, onConfirm}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop='static'
      keyboard={false}
      contentClassName='border-0 rounded-4'
    >
      <Modal.Body className='p-0'>
        <div className='text-center pt-8 px-7'>
          <div
            className='d-inline-flex align-items-center justify-content-center rounded-circle mb-5'
            style={{
              width: 64,
              height: 64,
              backgroundColor: '#F4F4E4',
            }}
          >
            <i
              className='bi bi-wifi'
              style={{fontSize: 30, color: 'rgb(163, 162, 66)'}}
            ></i>
          </div>
          <h2 className='fw-bolder text-dark mb-3' style={{fontSize: 22}}>
            Connection Test Required
          </h2>
          <p className='text-gray-600 fs-6 mb-0 px-4' style={{lineHeight: 1.6}}>
            Test your internet connection before starting. This ensures a stable, high-quality
            audio experience for both you and the client during upcoming sessions.
          </p>
        </div>
        <div
          className='d-flex justify-content-end align-items-center px-7 py-5 mt-7'
          style={{borderTop: '1px solid #EDEEF1'}}
        >
          <button
            type='button'
            className='btn btn-light me-3 fw-semibold'
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type='button'
            className='btn fw-semibold'
            style={{backgroundColor: 'rgb(163, 162, 66)', color: '#fff'}}
            onClick={onConfirm}
          >
            Test Connection
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ConnectionTestRequiredModal
